import React from 'react';
import ComponentName from '../constant/ComponentName';
import DomainConfigurationListViewerComponent from '../components/investigation/configuration/DomainConfigurationListViewerComponent';
import { FormicaProps, withFormica } from '../helpers/withFormica';
import { RootState } from '../redux/store';
import { changePageFilter, clearPage } from '../redux/actions/PageActions';
import { connect, ConnectedProps } from 'react-redux';
import CollectionNames from '../constant/CollectionNames';
import { CaseSettings } from '../domain/case/CaseDomains';
import ServiceContainer from '../config/ServiceContainer';
import { ServiceNames } from '../constant/ServiceNames';
import { ComponentState, setSelectedItems } from '../redux/actions/ComponentActions';
import DomainConfigurationService from '../service/DomainConfigurationService';
import StandardContainerComponent, { StandardSubscriptionComponentArgs } from '../helpers/StandardContainerComponent';
import LanguageUtil from '../util/LanguageUtil';
import { BulkActionDependencyError } from 'redux/reducers/BulkActionReducer';

class ConfigurationContainer extends StandardContainerComponent<Props, State, CaseSettings, {}> {
  private readonly configurationService: DomainConfigurationService = ServiceContainer.getInstance().get(ServiceNames.DOMAIN_CONFIGURATION);

  constructor(props: Props) {
    const args: StandardSubscriptionComponentArgs = {
      component: ComponentName.CONFIGURATION,
      withSchema: false,
      itemCollection: CollectionNames.CASE_SETTINGS,
      label: LanguageUtil.get({ id: 'common.label.configuration', defaultMessage: 'Configuration' }),
    };
    super(props, args);
  }

  protected getListView(): React.ReactNode {
    const { items, itemBuilderView } = this.state;
    return (
      <DomainConfigurationListViewerComponent
        views={itemBuilderView?.getListViews()}
        domains={items}
        currentModal={itemBuilderView?.getLastCurrent()}
        openEvent={this.openComponent}
        onSortChange={this.onSortChange}
      />
    );
  }

  protected async prepareCount() {
    const count = await this.configurationService.count(this.getCountFilter().build());
    this.setState({ totalRecord: count });
  }

  protected async removeAll(): Promise<BulkActionDependencyError[]> {
    const {
      component: { selectedComponentIds },
    } = this.props;
    this.configurationService.removeAll(selectedComponentIds as CaseSettings[]);
    return [];
  }

  protected undeployAll(): Promise<BulkActionDependencyError[]> {
    return Promise.resolve([]);
  }

  protected deployAll(): Promise<BulkActionDependencyError[]> {
    return Promise.resolve([]);
  }
}

interface Props extends ReduxProps, FormicaProps {}

const mapStateToProps = (state: RootState) => ({
  itemView: state.page.itemView,
  pagePath: state.page.pagePath,
  currentCategory: state.page.currentCategory,
  component: state.component as ComponentState,
  user: state.auth.user,
  attributes: state.auth.attributes,
});
const mapDispatchToProps = { clearPage, setSelectedItems, changePageFilter };
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

class State {}

export default withFormica(connector(ConfigurationContainer));
